import BatchOrderItem from '../BatchOrderItem';
import {Box} from '../../../components/core/view';
import {OrderItems} from '../../../batchDetails/types';
import React from 'react';
import {isWeb} from '@buncha/utils/common';

interface RecheckSheetItemProps {
  orderItem: OrderItems;
  runId: number | undefined;
}

function RecheckSheetItem(props: RecheckSheetItemProps) {
  const {orderItem} = props;
  // const theme = useColorThemeType();
  // const muliFont = useFontTheme('muli');
  // const isOrganic = orderItem?.name?.toLocaleLowerCase()?.includes('organic');

  return (
    <Box>
      <BatchOrderItem
        runId={props?.runId}
        esIndex=""
        orderItem={orderItem}
        isRecheckItem={true}
        rightIcon={<Box />}
        onClick={() => {
          return;
        }}
        disableOnclick={!isWeb()}
        // rightComponent={
        //   <If condition={isOrganic}>
        //     <Box style={styles.container}>
        //       <HBox style={[styles.topPill]}>
        //         <HBox
        //           style={[
        //             styles.infoBox,
        //             {
        //               backgroundColor: theme?.background?.orange?.[100],
        //             },
        //           ]}>
        //           <LeafBorderIcon
        //             fill={theme?.text?.white?.[100]}
        //             height={20}
        //             width={20}
        //             viewBox="4 0 15 25"
        //           />
        //           <H6Text
        //             style={[
        //               styles.infoText,
        //               {
        //                 color: theme?.text?.white?.[100],
        //                 fontFamily: muliFont[700].normal,
        //               },
        //             ]}>
        //             Organic
        //           </H6Text>
        //         </HBox>
        //       </HBox>
        //       <If condition={orderItem?.itemUnit}>
        //         <HBox
        //           style={[
        //             styles.infoBox,
        //             {
        //               backgroundColor: theme?.background.yellow[200],
        //             },
        //           ]}>
        //           <HourGlass
        //             fill={theme?.background.blue[300]}
        //             height={20}
        //             width={20}
        //             viewBox="0 -7 15 25"
        //           />
        //           <H6Text
        //             style={[
        //               styles.infoText,
        //               {
        //                 color: theme?.text.blue[300],
        //                 fontFamily: muliFont[700].normal,
        //               },
        //             ]}>{`Weight - ${orderItem?.itemUnit}`}</H6Text>
        //         </HBox>
        //       </If>
        //     </Box>
        //   </If>
        // }
      />
    </Box>
  );
}

export default React.memo(RecheckSheetItem);
